import { Component, Input, OnInit } from '@angular/core';
import { RadioButtonGroupComponent } from '../radio-button-group/radio-button-group.component';

@Component({
    selector: 'app-radio-button-icon',
    templateUrl: './radio-button-icon.component.html',
    styleUrls: ['./radio-button-icon.component.scss'],
    standalone: false
})
export class RadioButtonIconComponent implements OnInit {

  @Input() icon = '';

  constructor(
    public radioButtonGroup: RadioButtonGroupComponent,
  ) { }

  ngOnInit(): void {}

}
